<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import MondialLogo from '@/components/MondialLogo';
import Sidebar from '@/components/Course_B/Sidebar';
import Part from '@/components/Course_B/Part';
import Courses from '@/views/User/Courses';

export default {
  name: 'Home',
  components: {
    Sidebar,
    Part,
    Courses,
    MondialLogo,
  },
  computed: {
    ...mapState('user', [
      'courses',
      'course',
    ]),
    ...mapGetters('user', [
      'courseComponent',
    ]),
    component() {
      if (this.course) {
        return 'Part';
      }
      else if (this.courses && this.courses.length > 1) {
        return 'Courses';
      }

      return null;
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchCourses',
    ]),
    ...mapMutations('user', [
      'setCourse',
    ]),
    ...mapActions('user', [
      'fetchCourse',
    ]),
  },
  created() {
    this.fetchCourses()
      .then(() => {
        if (this.courses && this.courses.length === 1) {
          this.setCourse(this.courses[0]);
          const { id } = this.courses[0];
          this.fetchCourse(id);
        }
      })
    ;
  },
};
</script>
<template>
    <div id="course" class="pb-5">
        <div class="bg-white" v-if="component">
            <div class="container" v-if="course">
                <div class="row pt-5 pb-5">
                    <div class="col-6 d-flex align-items-center">
                        <h4>{{ course.title }}</h4>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                    <MondialLogo />
                    </div>
                </div>
            </div>
            <div class="container" v-else>
                <div class="bg-white pt-5 pb-5">
                    <h2 class="text-center">Wybierz interesujące Cię szkolenie</h2>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row pt-3" v-if="component">
                <div class="col-lg-4" v-if="course">
                    <Sidebar />
                </div>
                <div :class="{ 'col-lg-12': !course, 'col-lg-8': course}">
                    <Component :is="component" :isDirect="false" />
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12">
                    <div class="alert-info p-3">
                        Nie masz żadnego aktywnego kursu
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
